import { apiSlice } from 'store/slices/api/api-slice';
import { AddRuleResponse, CountryData, RuleList } from 'types/rule/rule';
import { RuleProductList } from 'types/rule/rule-condition';

export const ruleEnumApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        entitiesList: builder.query<string[], void>({
            query: () => ({
                url: '/rule/entities-enum',
                method: 'GET',
            }),
        }),

        countryList: builder.query<CountryData[], void>({
            query: () => ({
                url: '/country/names-list',
                method: 'GET',
            }),
        }),

        operatorList: builder.query<string[], void>({
            query: () => ({
                url: '/rule/operator-enum',
                method: 'GET',
            }),
        }),

        ruleProductList: builder.query<RuleList[], RuleProductList>({
            query: (params) => ({
                url: '/rule/rule-name-list',
                method: 'GET',
                params,
            }),
        }),

        ruleIdList: builder.query<AddRuleResponse, string>({
            query: (ruleId: string) => ({
                url: `/rule/rule/` + ruleId,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useEntitiesListQuery,
    useCountryListQuery,
    useOperatorListQuery,
    useRuleProductListQuery,
    useLazyRuleIdListQuery,
} = ruleEnumApi;
